import headerImage from "../../assets/images/game-supergirls/TamhaRak_Poster.jpg";
import logoImage from "../../assets/images/game-supergirls/logo-big.webp";
import BiggyImage from "../../assets/images/game-supergirls/Sticker-Thx.png";
import { useNavigate, useLocation } from 'react-router-dom';

export default function AlreadyPlayedScreen() {
  const navigate = useNavigate();

  const DRAMA_URL = "https://www.one31.net/shows/detail/590";

  const goLink = () => {
    window.open(DRAMA_URL, "_blank");
  };

  const goLinkReward = () => {
    navigate("/game/rewards");
  };

  return (
    <div className="quiz-container">
      <img
        src={headerImage}
        alt="ตามหารักที่เธอลืม"
        className="quiz-header-image"
      />

      <div className="question-card-wrapper">
        <div className="question-card">
          <div className="flex flex-col items-center text-center px-6 py-16">
            <h2 className="text-2xl font-bold text-red-600 mb-4">
              🎉 คุณได้ตอบคำถามประจำวันแล้ว!
            </h2>

            <p className="text-lg text-gray-700 mb-8">
              กลับมาร่วมเล่นสนุกใหม่ในวันพรุ่งนี้ ❤️
            </p>

            <button
              onClick={() => goLink()}
              className="btn-border-3d flex items-center justify-center gap-2"
            >
              ดูละครย้อนหลัง
            </button>
            <br/>
            <button
              onClick={() => goLinkReward()}
              className="btn-border-3d flex items-center justify-center gap-2"
            >
              ดูประวัติรางวัล
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
